import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import mapData from "./data/usStatesMap.json";
import BackHomeLink from "./BackHomeLink";

const QUIZ_STATES = mapData.states.filter((s) => s.abbr !== "DC");
const [VB_X, VB_Y, VB_W, VB_H] = mapData.viewBox.split(" ").map(Number);

function pickTarget(excludeAbbr) {
  let candidate;
  do {
    candidate = QUIZ_STATES[Math.floor(Math.random() * QUIZ_STATES.length)];
  } while (QUIZ_STATES.length > 1 && candidate.abbr === excludeAbbr);
  return candidate;
}

function StateMapQuiz() {
  const [target, setTarget] = useState(() => pickTarget(null));
  const [feedback, setFeedback] = useState(null); // { clickedAbbr, correct }
  const [history, setHistory] = useState([]);
  const [finished, setFinished] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleGuess = (state) => {
    if (feedback || finished) return;
    const correct = state.abbr === target.abbr;
    setFeedback({ clickedAbbr: state.abbr, correct });
    setHistory((prev) => [
      ...prev,
      { target: target.name, clicked: state.name, correct },
    ]);
    timeoutRef.current = setTimeout(() => {
      setFeedback(null);
      setTarget((prevTarget) => pickTarget(prevTarget.abbr));
    }, 1200);
  };

  const handleEnd = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setFinished(true);
  };

  const handleRestart = () => {
    setHistory([]);
    setFeedback(null);
    setFinished(false);
    setTarget(pickTarget(null));
  };

  if (finished) {
    const correctCount = history.filter((h) => h.correct).length;
    const wrongCount = history.length - correctCount;
    const wrongAnswers = history.filter((h) => !h.correct);

    return (
      <div>
        <h2>Map Quiz Complete!</h2>
        <div>
          <strong>Correct:</strong> {correctCount}{" "}
          <span style={{ color: "green" }}>✔️</span>
          <br />
          <strong>Wrong:</strong> {wrongCount}{" "}
          <span style={{ color: "red" }}>❌</span>
        </div>
        {wrongAnswers.length > 0 && (
          <>
            <h3>Answers to review:</h3>
            <ul>
              {wrongAnswers.map((h, i) => (
                <li key={i}>
                  Correct answer: <strong>{h.target}</strong> — You clicked:{" "}
                  {h.clicked}
                </li>
              ))}
            </ul>
          </>
        )}
        <button onClick={handleRestart}>Play Again</button>
        &nbsp;
        <Link to="/" className="back-home-btn">
          &#8592; Home
        </Link>
      </div>
    );
  }

  return (
    <div>
      <BackHomeLink />
      <h2>Click on: {target.name}</h2>
      <div>
        <strong>Correct:</strong> {history.filter((h) => h.correct).length}{" "}
        &nbsp;|&nbsp; <strong>Wrong:</strong>{" "}
        {history.filter((h) => !h.correct).length}
      </div>
      <div
        style={{
          background: "none",
          boxShadow: "none",
          padding: 0,
          margin: "16px 0",
          minWidth: "unset",
        }}
      >
        <svg
          viewBox={mapData.viewBox}
          shapeRendering="geometricPrecision"
          style={{ width: "100%", maxWidth: 720, height: "auto" }}
        >
          <rect x={VB_X} y={VB_Y} width={VB_W} height={VB_H} fill="#eaf4fb" />
          {mapData.states.map((state) => {
            let fill = "#cfe8fc";
            if (feedback) {
              if (state.abbr === target.abbr) {
                fill = "#4caf50";
              } else if (state.abbr === feedback.clickedAbbr) {
                fill = feedback.correct ? "#4caf50" : "#e53935";
              }
            }
            return (
              <path
                key={state.id}
                d={state.d}
                fill={fill}
                stroke="#2c3e50"
                strokeWidth={1.5}
                strokeLinejoin="round"
                vectorEffect="non-scaling-stroke"
                onClick={() =>
                  state.abbr !== "DC" ? handleGuess(state) : undefined
                }
                style={{ cursor: state.abbr === "DC" ? "default" : "pointer" }}
              />
            );
          })}
        </svg>
      </div>
      <button onClick={handleEnd}>End Quiz</button>
    </div>
  );
}

export default StateMapQuiz;
